// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WorkbookVariantRewriteQueryVariables = Types.Exact<{
  variantId: Types.Scalars["ID"]["input"];
  rewriteType: Types.Scalars["String"]["input"];
  insight: Types.Scalars["String"]["input"];
}>;

export type WorkbookVariantRewriteQuery = {
  __typename?: "GraphqlQuery";
  getWorkbookVariantRewrite: {
    __typename?: "WorkbookVariantRewriteQuery";
    id: string;
    query: string;
    queryWithAlias: string;
  };
};

export const WorkbookVariantRewriteDocument = gql`
  query WorkbookVariantRewrite(
    $variantId: ID!
    $rewriteType: String!
    $insight: String!
  ) {
    getWorkbookVariantRewrite(
      variantId: $variantId
      rewriteType: $rewriteType
      insight: $insight
    ) {
      id
      query
      queryWithAlias
    }
  }
`;

/**
 * __useWorkbookVariantRewriteQuery__
 *
 * To run a query within a React component, call `useWorkbookVariantRewriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbookVariantRewriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbookVariantRewriteQuery({
 *   variables: {
 *      variantId: // value for 'variantId'
 *      rewriteType: // value for 'rewriteType'
 *      insight: // value for 'insight'
 *   },
 * });
 */
export function useWorkbookVariantRewriteQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkbookVariantRewriteQuery,
    WorkbookVariantRewriteQueryVariables
  > &
    (
      | { variables: WorkbookVariantRewriteQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorkbookVariantRewriteQuery,
    WorkbookVariantRewriteQueryVariables
  >(WorkbookVariantRewriteDocument, options);
}
export function useWorkbookVariantRewriteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkbookVariantRewriteQuery,
    WorkbookVariantRewriteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkbookVariantRewriteQuery,
    WorkbookVariantRewriteQueryVariables
  >(WorkbookVariantRewriteDocument, options);
}
// @ts-ignore
export function useWorkbookVariantRewriteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkbookVariantRewriteQuery,
    WorkbookVariantRewriteQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkbookVariantRewriteQuery,
  WorkbookVariantRewriteQueryVariables
>;
export function useWorkbookVariantRewriteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbookVariantRewriteQuery,
        WorkbookVariantRewriteQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkbookVariantRewriteQuery | undefined,
  WorkbookVariantRewriteQueryVariables
>;
export function useWorkbookVariantRewriteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbookVariantRewriteQuery,
        WorkbookVariantRewriteQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkbookVariantRewriteQuery,
    WorkbookVariantRewriteQueryVariables
  >(WorkbookVariantRewriteDocument, options);
}
export type WorkbookVariantRewriteQueryHookResult = ReturnType<
  typeof useWorkbookVariantRewriteQuery
>;
export type WorkbookVariantRewriteLazyQueryHookResult = ReturnType<
  typeof useWorkbookVariantRewriteLazyQuery
>;
export type WorkbookVariantRewriteSuspenseQueryHookResult = ReturnType<
  typeof useWorkbookVariantRewriteSuspenseQuery
>;
export type WorkbookVariantRewriteQueryResult = Apollo.QueryResult<
  WorkbookVariantRewriteQuery,
  WorkbookVariantRewriteQueryVariables
>;
